import { CHAT_BOT } from "@modules/features/constants";
import { TFeatures } from "@modules/features/types";

export const checkIfChatBotEnabled = (features: TFeatures): boolean => features?.includes(CHAT_BOT);
